<template>
    <b-modal
        @ok="generateReport"
        class="pt-8"
        v-model="showModal"
        title="Select Report Type"
    >
        <template #default>
            <b-form class="mt-3" submit.prevent="doNothing()">
                <b-form-group label="Report Types" v-slot="{ ariaDescribedby }">
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="asset_details"
                        id="asset_details"
                        >Asset Service History</b-form-radio
                    >
                    <b-form-radio
                        v-model="reportType"
                        :aria-describedby="ariaDescribedby"
                        name="reportTypeGroup"
                        value="asset_header"
                        id="asset_header"
                        >Asset Summary Report</b-form-radio
                    >
                </b-form-group>

                <div v-if="!!reportUrl">
                    <a :href="reportUrl" target="_blank" download
                        >Click To Download Report</a
                    >
                </div>
            </b-form>
        </template>

        <template #modal-footer="{ ok, cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button
                size="sm"
                :disabled="!reportType"
                variant="success"
                @click="ok()"
            >
                <b-spinner
                    v-show="loading"
                    variant="primary"
                    label="Spinning"
                ></b-spinner>
                <span v-show="!loading">Create Report</span>
            </b-button>
            <b-button size="sm" variant="danger" @click="cancel()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
export default {
    mixins: [popupMixins],
    data() {
        return {
            reportUrl: null,
            showModal: false,
            loading: false,
            reportType: null,
            resetCounter: 0,
            queryModel: {},
        }
    },
    props: ['queryData'],
    computed: {
        baseReportUrl() {
            return this.$store.getters['js_report/reportUrl']
        },
    },

    watch: {
        reportType: function () {
            this.reportUrl = null
        },
        queryData: function (val) {
            this.queryModel = val || {}
        },
    },
    mounted() {
        this.queryModel = this.queryData || {}
    },
    methods: {
        show() {
            this.showModal = true
        },
        close() {
            this.showModal = false
        },
        async generateReport(evt) {
            evt.preventDefault()
            try {
                const { reportType: rpt_type } = this
                this.queryModel = {
                    ...this.queryModel,
                    ...{ rpt_type },
                }
                this.loading = true

                console.log('queryModel', this.queryModel)
                await this.$store.dispatch(
                    'js_report/fetchCredentials',
                    rpt_type
                )
                await this.$nextTick()
                this.reportUrl = `${this.baseReportUrl}&query=${btoa(
                    JSON.stringify(this.queryModel)
                )}`
                console.log('reportUrl', this.reportUrl)
            } catch (err) {
                this.doToast(
                    'Error!',
                    'Error Detected. Please consult your System Administrator',
                    'danger'
                )
            } finally {
                this.loading = false
            }
        },

        doNothing() {},
    },
}
</script>

<style scoped>
</style>